import { useLocation } from "react-router-dom";

export function useCheckRoute() {
  const location = useLocation();
  const currentPath = location.pathname;

  return !(currentPath === "/dashboard" || currentPath === "/super-admin-login");
}